import { ApolloError, useMutation } from "@apollo/client";

import {
  ReplaceNodeMutation,
  ReplaceNodeMutationVariables,
} from "../../../API";
import { REPLACE_NODE } from "../../../common/operations/mutations";
import {
  errorNotification,
  successNotification,
} from "../../../common/variables/notification";

export const useReplaceNode = () => {
  const [replaceNodeMutation, { data, loading }] = useMutation<
    ReplaceNodeMutation,
    ReplaceNodeMutationVariables
  >(REPLACE_NODE);

  const replaceNode = async (nodeId: string, nodeName: string) => {
    return await replaceNodeMutation({
      variables: {
        input: { nodeId },
      },
      onCompleted: response => {
        if (response.replaceNode) {
          successNotification(
            `${nodeName} node certificate replaced successfully`
          );
        }
      },
      onError: (error: ApolloError): void => {
        errorNotification(
          `Something went wrong, ${nodeName} certificate wasn't replaced`
        );

        console.error(error.message);
      },
    });
  };

  return { replaceNode, data, loading };
};
